(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('OggettoConsenso', OggettoConsenso);

    OggettoConsenso.$inject = ['$resource'];

    function OggettoConsenso ($resource) {
        var resourceUrl =  'api/oggetto-consensos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
